<template>
  <div
    ref="itemRef"
    class="dict-item"
    :class="{ active: checkActive(props.data) || !!checkTags?.length }"
  >
    <template v-if="data?.children?.length">
      <a-dropdown
        v-model:open="visible"
        placement="bottomLeft"
        destroyPopupOnHide
        :getPopupContainer="getPopupContainer"
        :overlayStyle="{ whiteSpace: 'nowrap' }"
      >
        <div class="h-full flex-y-center">
          <a
            class="cursor-pointer font-normal"
            :href="`/template?tag_ids=${data.children
              .map((item) => item.ids)
              .join('_')}`"
            :class="
              checkActive(props.data) || !!checkTags?.length
                ? 'text-font-80'
                : 'text-font-60'
            "
            @click="handClick"
          >
            {{ data.tag_name }}
          </a>
          <template v-if="checkTags?.length">
            <CloseCircleFilled class="close-icon" @click="handleClose" />
            <span>：</span>
            <div class="flex gap-x-[2px]">
              <span
                v-for="x in checkTags"
                :key="x.tag_id"
                class="check-tag cursor-pointer flex-y-center"
                @click="onChildChange(false, x)"
              >
                {{ x.tag_name }}
                <CloseOutlined class="text-[9px] ml-[6px]" />
              </span>
            </div>
          </template>
          <a-divider type="vertical" />
          <iconpark-icon name="down" size="10" />
        </div>
        <template #overlay>
          <a-menu>
            <a-menu-item
              v-for="x in data.children"
              :key="x.tag_id"
              class="item-menu"
            >
              <a-checkbox
                class="check"
                :checked="checkActive(x)"
                :value="x.tag_id"
                @change="onChildChange($event.target.checked, x)"
              >
                {{ x.tag_name }}
              </a-checkbox>
            </a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>
    </template>
    <span v-else class="cursor-pointer item-link" @click="handClick">
      {{ data.tag_name }}
    </span>
  </div>
</template>

<script lang="ts" setup>
import type { Tag } from '~/api/interface'

const props = defineProps<{ data: Tag; checks: Tag[] }>()
const emit = defineEmits(['change'])
const visible = ref(false)
const itemRef = ref<HTMLElement>()

const checkActive = (data: Tag) => {
  return props?.checks?.findIndex((x) => x.ids === data.ids) !== -1
}

const checkTags = computed(() => {
  if (!props.data?.children?.length) {
    return []
  }

  return props?.data?.children?.filter((x: Tag) => checkActive(x)) || []
})

const handleClose = () => {
  visible.value = false
  checkTags.value.forEach((x) => emit('change', x, false))
}

const handClick = (e: Event) => {
  e.preventDefault()

  if (props?.data?.children?.length) {
    if (props?.data?.children?.length === checkTags.value.length) {
      emit('change', props?.data?.children, false)
    } else {
      emit('change', props?.data?.children, true)
    }
  } else {
    emit('change', props.data, !checkActive(props.data))
  }
}

const onChildChange = (checked: boolean, data: Tag) => {
  emit('change', data, checked)
}

const getPopupContainer = () => {
  return itemRef.value as HTMLElement
}
</script>

<style lang="scss" scoped>
.dict-item {
  @apply p-[4px_10px] rounded-[6px] text-font-60 flex-y-center relative hover:text-primary;

  .item-link {
    color: var(--text-1-60);
  }

  &.active {
    @apply font-semibold text-primary bg-back-2;

    .item-link {
      @apply font-semibold text-primary bg-back-2;
    }
  }
  .close-icon {
    @apply absolute -top-[6px] right-[-6px] text-back-6 hidden;
  }
  &:hover {
    .close-icon {
      @apply block;
    }
  }
}
.check-tag {
  @apply p-[4px_10px] rounded-[6px] leading-[1em] bg-back-1;
}
.item-menu {
  &:hover .check,
  .ant-checkbox-wrapper-checked {
    @apply text-primary;
  }
}
</style>
